/*eslint-disable*/ import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
// @mui/icons-material
import FormatAlignLeft from "@mui/icons-material/FormatAlignLeft";
import ContactMail from "@mui/icons-material/ContactMail";
import Phone from "@mui/icons-material/Phone";
import Favorite from "@mui/icons-material/Favorite";
// core components
//Use the HeaderTribalism2 element when adding in the top banner!!
//import Header from "components/Header/HeaderTribalism2.js";
import Header from "components/Header/HeaderTribalism.js";
import HeaderLinks from "components/Header/HeaderLinksTribalism.js";
//import Parallax from "components/Parallax/Parallax.js";
import Parallax from "components/Parallax/Parallax_noscale.js";
import Footer from "components/Footer/TribalismFooter.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";

// sections for this page
import AboutUs from "pages-sections/services/google-ads-services/AboutUs.js";
import Examples from "pages-sections/services/google-ads-services/Examples.js";
import AdsPackage from "pages-sections/services/google-ads-services/AdsPackage.js";
import Guarantee from "pages-sections/services/google-ads-services/Guarantee.js";
import WhyUs from "pages-sections/services/google-ads-services/WhyUs.js";
import OurApproach from "pages-sections/services/google-ads-services/OurApproach.js";

import SectionText from "pages-sections/services/google-ads-services/SectionText.js";

import SectionBlogInfo from "pages-sections/blog-post/SectionBlogInfo.js";
import SectionComments from "pages-sections/blog-post/SectionComments.js";
import SectionSimilarStories from "pages-sections/blog-post/SectionSimilarStories.js";
import Section4Clients from "pages-sections/home-page/Section4ClientsLandingPage.js";
import Section8Contacts from "pages-sections/home-page/Section8Contacts.js";

//import classNames from "classnames";
import Box from "@mui/material/Box";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import Image from "next/image";

////


import Banner from "components/Banner/Banner.js";
import SimilarPages from "pages-sections/glossary/SimilarPages.js";

import data from "data/linksData3.js"; // Adjust the path accordingly
import styles from "../../../pages-sections/services/ServicesSections.module.scss";


const main_section = "web_analytics";
const sub_section = "fundamental_concepts";
const this_page = "Hit";

export async function getStaticPaths() {
  // Assume data is imported or defined here
  // const data = require("data/linksData3.js");

  // Function to extract links from an object
  const extractLinks = (obj) => {
    return obj && obj.links
      ? obj.links.map((link) => ({ params: { fname: link.fname } }))
      : [];
  };

  // Extract links from different objects
  const fundamentalConceptsLinks = extractLinks(
    data.web_analytics.fundamental_concepts
  );
  const sourcesAndTrafficLinks = extractLinks(
    data.web_analytics.sources_and_channels
  );

  const content_and_user_interactionLinks = extractLinks(
    data.web_analytics.content_and_user_interaction
  );
  const attribution_and_conversion_pathLinks = extractLinks(
    data.web_analytics.attribution_and_conversion_path
  );
  const users_and_segmentationLinks = extractLinks(
    data.web_analytics.users_and_segmentation
  );
  const search_and_keywordsLinks = extractLinks(
    data.web_analytics.search_and_keywords
  );
  const advertising_metricsLinks = extractLinks(
    data.web_analytics.advertising_metrics
  );

  const advanced_features_and_toolsLinks = extractLinks(
    data.web_analytics.advanced_features_and_tools
  );

  const testing_and_optimizationLinks = extractLinks(
    data.web_analytics.testing_and_optimization
  );

  const e_commerce_metricsLinks = extractLinks(
    data.web_analytics.e_commerce_metrics
  );
  // Add more objects here if needed e_commerce_metrics

  // Combine all links
  const allLinks = [
    ...fundamentalConceptsLinks,
    ...sourcesAndTrafficLinks,
    ...content_and_user_interactionLinks,
    ...attribution_and_conversion_pathLinks,
    ...users_and_segmentationLinks,
    ...search_and_keywordsLinks,
    ...advertising_metricsLinks,
    ...advanced_features_and_toolsLinks,
    ...testing_and_optimizationLinks,
    ...e_commerce_metricsLinks,
  ];
  // Add more arrays here if needed

  return { paths: allLinks, fallback: false };
}

export async function getStaticProps({ params }) {
  // const data = require("data/linksData3.js"); // Adjust path to your actual data file

  let pageData = null;
  let parentObjectName = null;

  // Loop through each key in web_analytics
  for (const key in data.web_analytics) {
    if (data.web_analytics.hasOwnProperty(key)) {
      const obj = data.web_analytics[key];
      //console.log("Checking in object:", key); // Debugging output
      const foundLink = obj.links.find((link) => link.fname === params.fname);
      if (foundLink) {
        //console.log("Found link in:", key); // Debugging output
        pageData = foundLink;
        parentObjectName = key;
        break; // Found the link, break out of the loop
      }
    }
  }

  // If no pageData is found, return notFound
  if (!pageData) {
    return { notFound: true };
  }

  // Return both pageData and the name of its parent object
  return { props: { pageData, parentObjectName } };
}

export default function BlogPostPage({ pageData, parentObjectName }) {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });
  const classes = styles;

  // Extract the description from pageData
  const pageDescription = pageData.description;
  const pageName = pageData.name;
  const pageTitle = pageData.name + "- Definition - Tribalism";
  const pageSection = parentObjectName;

  return (
    <div>
      <Header
        brand="/img/clients/TribalismLogoRev.webp"
        links={<HeaderLinks dropdownHoverColor="info" />}
        fixed
        color="transparent"
        title={pageTitle}
        //image="/img/sections/services/all-services/4-sm.webp"
        image="/img/sections/services/all-services/melbourne-sm.webp"
        url="https://www.tribalism.com.au/services/web-analytics"
        type="article"
        //description="We are an Analytics, Web Development and Digital Marketing Agency based in Melbourne. We can get started on big-impact projects for your business immediately! Reach out any time."
        description={
          pageDescription ||
          "We are an Analytics, Web Development and Digital Marketing Agency based in Melbourne. We can get started on big-impact projects for your business immediately! Reach out any time."
        }
        changeColorOnScroll={{
          height: 300,
          color: "info",
        }}
      />

      <Parallax
        image="/img/sections/services/all-services/7-sm.webp"
        filter="dark"
      ></Parallax>

      <div className={classes.main} style={{ marginTop: "30px" }}>
        <div
          style={{
            backgroundSize: "100% 100%",
            backgroundImage: "url('/img/bgs/bgpink2.jpg')",
            //boxShadow:
            //  "0 4px 20px 0px rgb(0 0 0 / 14%), 0 7px 12px -5px rgb(0 172 193 / 46%)",
          }}
        >
          <div className={classes.container}>
            <div className={classes.sectionGlossary} style={{ padding: "0px" }}>
              <GridContainer
                alignItems="center"
                spacing={8}
                style={{ padding: "0px" }}
              >
                <GridItem xs={12} sm={10} md={10} lg={10}>
                  <h2 className={classes.title}>{pageName}</h2>
                  <h3 className={classes.title}>Definition</h3>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: pageData.content.join(" "),
                    }}
                  />
                  <br /> <br />
                </GridItem>
              </GridContainer>
            </div>
          </div>
        </div>
        <SimilarPages
          main_section={main_section}
          sub_section={pageSection}
          this_page={pageName}
        />

        <Section8Contacts id="testimonials" />
      </div>
      <Footer
        content={
          <div>
            <div className={classes.left}></div>
          </div>
        }
      />
    </div>
  );
}
